export const PRICES_UPDATE_INTERVAL = 1000;
export const PRICES_CACHE_TTL = 30_000;
export const LEADERBOARD_PRICES_UPDATE_INTERVAL = 60000;

export const FREQUENT_UPDATE_INTERVAL = 5000;
export const CONFIG_UPDATE_INTERVAL = 60000;

export const FREQUENT_MULTICALL_REFRESH_INTERVAL = 500;
